var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fanqizha-layer"},[_c('caseheader'),_c('div',{staticClass:"fz-container"},[_c('div',{staticClass:"fz-content"},[_c('casedata')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }